import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { useResetRecoilState } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../routes/types';
import {
  basketAdvisorOrderIdState,
  customerCartState,
  customerCartStatusState,
  productsCartState,
  productsCartStatusState,
} from '../../../store/batchTicket/atom';

export const useHeader = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const isMobile = useBreakpointValue({ base: true, sm: false });
  const resetBasketAdvisorOrderId = useResetRecoilState(basketAdvisorOrderIdState);
  const resetCustomerCartState = useResetRecoilState(customerCartState);
  const resetCustomerCartStatusState = useResetRecoilState(customerCartStatusState);
  const resetProductsCartState = useResetRecoilState(productsCartState);
  const resetProductsCartStatusState = useResetRecoilState(productsCartStatusState);

  const handleGoBack = () => {
    navigate('Cockpit');
  };

  const handleCreateBatchTicketOrder = () => {
    resetBasketAdvisorOrderId();
    resetCustomerCartState();
    resetCustomerCartStatusState();
    resetProductsCartState();
    resetProductsCartStatusState();

    navigate('BatchTicket');
  };

  const handleRedeemBatchTicketOrder = () => {
    navigate('RedeemBatchTicket');
  };

  return {
    handleGoBack,
    handleCreateBatchTicketOrder,
    isMobile,
    handleRedeemBatchTicketOrder,
  };
};
